import React, { createContext, useMemo, useState } from "react";
import { PREFERRED_LANGUAGE } from "../vars";
import English from "../utils/EnglishLanguage.json";
import Hindi from "../utils/HindiLanguage.json";
import French from "../utils/FrenchLanguage.json";
import German from "../utils/GermanLanguage.json";
import Spanish from "../utils/SpanishLanguage.json";
import Arabic from "../utils/ArabicLanguage.json";
import Italian from "../utils/ItalianLanguage.json";

export const LanguageContext = createContext();

export default function LanguageContextProvider({ children }) {
  const [preferredLanguage, setPreferredLanguage] = useState(PREFERRED_LANGUAGE.ENGLISH);

  const translate = (text) => {
    switch (preferredLanguage) {
      case PREFERRED_LANGUAGE.HINDI: {
        return Hindi[text];
      }
      case PREFERRED_LANGUAGE.FRENCH: {
        return French[text];
      }
      case PREFERRED_LANGUAGE.GERMAN: {
        return German[text];
      }
      case PREFERRED_LANGUAGE.SPANISH: {
        return Spanish[text];
      }
      case PREFERRED_LANGUAGE.ARABIC: {
        return Arabic[text];
      }
      case PREFERRED_LANGUAGE.ITALIAN: {
        return Italian[text];
      }
      default: {
        return English[text];
      }
    }
  };
  const value = useMemo(
    () => ({
      preferredLanguage,
      setPreferredLanguage,
      translate,
    }),
    [preferredLanguage]
  );
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}
